// 複数物件カードリスト（まとめて資料請求 / contact）
// SP横スクロール位置インジケーター + PC折りたたみ展開
// ×押下: Figma 5111:38159 → 5144:21698（半透明＋戻すアイコンへふわっと切替）
// SP pager: Figma 5155:23375
const estateCardList = () => {
    document.querySelectorAll('.js-estate-card-list-track').forEach((track) => {
        const wrapper = track.closest('.c-forms-estate-card-list');
        if (!wrapper) return;

        const indicator = wrapper.querySelector('.js-estate-card-list-current');
        const totalEl = wrapper.querySelector('.js-estate-card-list-total');
        const moreBtn = wrapper.querySelector('.js-estate-card-list-more');
        const prevBtn = wrapper.querySelector('.js-estate-card-list-prev');
        const nextBtn = wrapper.querySelector('.js-estate-card-list-next');

        let currentIndex = 0;
        let isProgrammaticScroll = false;
        let scrollSyncTimer = null;

        const items = () => [...track.querySelectorAll('.c-forms-estate-card-list__item')];
        const itemBox = (item) => item.querySelector('.c-forms-estate-card') ?? item;
        const activeItems = () => items().filter((el) => !el.classList.contains('is-removed'));

        const refreshTotal = () => {
            if (totalEl) totalEl.textContent = String(activeItems().length);
        };

        const updateNavState = () => {
            const list = items();
            if (prevBtn) prevBtn.disabled = currentIndex <= 0;
            if (nextBtn) nextBtn.disabled = currentIndex >= list.length - 1;
        };

        const setCurrent = (index) => {
            const list = items();
            if (!list.length) return;
            currentIndex = Math.max(0, Math.min(index, list.length - 1));
            if (indicator) indicator.textContent = String(currentIndex + 1);
            updateNavState();
        };

        const getItemScrollLeft = (index) => {
            const list = items();
            const card = itemBox(list[index]);
            if (!card) return 0;
            return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        };

        const syncIndexFromScroll = () => {
            const list = items();
            if (!list.length) return;

            const scrollLeft = track.scrollLeft;
            let closest = 0;
            let minDist = Infinity;

            list.forEach((item, index) => {
                const left = getItemScrollLeft(index);
                const dist = Math.abs(left - scrollLeft);
                if (dist < minDist) {
                    minDist = dist;
                    closest = index;
                }
            });

            setCurrent(closest);
        };

        const finishProgrammaticScroll = () => {
            isProgrammaticScroll = false;
        };

        const scrollToIndex = (index) => {
            const list = items();
            if (!list.length) return;

            const clamped = Math.max(0, Math.min(index, list.length - 1));
            const targetLeft = getItemScrollLeft(clamped);
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
            const left = Math.min(targetLeft, maxScroll);

            isProgrammaticScroll = true;
            setCurrent(clamped);
            track.scrollTo({ left, behavior: 'smooth' });

            clearTimeout(scrollSyncTimer);
            scrollSyncTimer = setTimeout(finishProgrammaticScroll, 400);
        };

        const setRemoved = (item, removed) => {
            const card = item.querySelector('.c-forms-estate-card');
            const btn = item.querySelector('.js-estate-card-remove');
            item.classList.toggle('is-removed', removed);
            card?.classList.toggle('is-removed', removed);
            if (btn) {
                btn.setAttribute('aria-pressed', removed ? 'true' : 'false');
                btn.setAttribute(
                    'aria-label',
                    removed ? 'この物件をリストに戻す' : 'この物件をリストから外す'
                );
            }
            item.querySelectorAll('.js-estate-card-id, .js-estate-card-name').forEach((input) => {
                input.disabled = removed;
            });
            refreshTotal();
        };

        if (indicator && items().length >= 2) {
            track.addEventListener(
                'scroll',
                () => {
                    if (isProgrammaticScroll) return;
                    clearTimeout(scrollSyncTimer);
                    scrollSyncTimer = setTimeout(syncIndexFromScroll, 80);
                },
                { passive: true }
            );

            track.addEventListener('scrollend', () => {
                if (isProgrammaticScroll) {
                    finishProgrammaticScroll();
                    return;
                }
                syncIndexFromScroll();
            });

            updateNavState();
        }

        prevBtn?.addEventListener('click', () => scrollToIndex(currentIndex - 1));
        nextBtn?.addEventListener('click', () => scrollToIndex(currentIndex + 1));

        if (moreBtn) {
            const moreLabel = wrapper.querySelector('.js-estate-card-list-more-label');
            const mqPc = window.matchMedia('(min-width: 1025px)');
            const PEEK_H = 158;

            const peekItems = () => items().slice(1);

            const setCollapsed = (collapsed) => {
                const extra = peekItems();

                if (mqPc.matches) {
                    extra.forEach((el, index) => {
                        if (collapsed) {
                            el.style.maxHeight = `${el.scrollHeight}px`;
                        } else {
                            el.style.maxHeight = index === 0 ? `${PEEK_H}px` : '0px';
                        }
                    });
                    void track.offsetHeight;
                }

                wrapper.classList.toggle('is-collapsed', collapsed);
                moreBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
                if (moreLabel) {
                    moreLabel.textContent = collapsed
                        ? '資料請求する物件をすべてみる'
                        : 'とじる';
                }

                if (!mqPc.matches) return;

                requestAnimationFrame(() => {
                    extra.forEach((el, index) => {
                        if (collapsed) {
                            el.style.maxHeight = index === 0 ? `${PEEK_H}px` : '0px';
                        } else {
                            el.style.maxHeight = `${el.scrollHeight}px`;
                        }
                    });
                });
            };

            wrapper.querySelectorAll('.c-forms-estate-card-list__item').forEach((el, index) => {
                if (index === 0) return;
                el.addEventListener('transitionend', (event) => {
                    if (event.propertyName !== 'max-height') return;
                    if (!wrapper.classList.contains('is-collapsed') && mqPc.matches) {
                        el.style.maxHeight = 'none';
                    }
                });
            });

            moreBtn.addEventListener('click', () => {
                setCollapsed(!wrapper.classList.contains('is-collapsed'));
            });
        }

        wrapper.addEventListener('click', (e) => {
            const btn = e.target.closest('.js-estate-card-remove');
            if (!btn) return;
            const item = btn.closest('.c-forms-estate-card-list__item');
            if (!item) return;
            setRemoved(item, !item.classList.contains('is-removed'));
        });
    });
};
export default estateCardList;
